import { render, staticRenderFns } from "./SfMenuItem.vue?vue&type=template&id=d9cfc482&"
import script from "./SfMenuItem.vue?vue&type=script&lang=ts&"
export * from "./SfMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./SfMenuItem.vue?vue&type=style&index=0&id=d9cfc482&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports